import clsx from 'clsx';
import { arrayOf, node, oneOf, oneOfType, shape, string } from 'prop-types';
import React, { createContext, useContext, useEffect } from 'react';

import { Icon } from 'components';
import { useSafeState } from 'hooks';

import 'assets/styles/components/navigation/tabs.scss';

export const TabsContext = createContext();

export const TabsProvider = ({ children, defaultTab = '' }) => {
  const [currentTab, setCurrentTab] = useSafeState('');

  useEffect(() => {
    setCurrentTab(defaultTab);
  }, [defaultTab]);

  return <TabsContext.Provider value={{ currentTab, setCurrentTab }}>{children}</TabsContext.Provider>;
};

export const Tabs = ({ tabs, className = '', type }) => {
  const { currentTab, setCurrentTab } = useContext(TabsContext);

  const handleTabChange = (tab) => {
    tab?.onClick && tab.onClick(tab);
    setCurrentTab(tab.identifier);
  };

  return (
    <ul className={clsx('tabs', className, type)}>
      {tabs.map((tab, i) => (
        <li key={`tab-${tab.identifier}-${i}`} className={clsx('tab', currentTab === tab.identifier && 'active')}>
          <button type="button" className="tab-btn uppercase" onClick={() => handleTabChange(tab)}>
            {tab?.icon?.name && <Icon name={tab.icon.name} iconStyle={tab.icon?.style} classes="tab-icon" />}
            {tab.label}
          </button>
        </li>
      ))}
    </ul>
  );
};

export const TabPanel = ({ children, identifier }) => {
  const { currentTab } = useContext(TabsContext);

  if (currentTab !== identifier) return null;
  return <div className="tab-content full-width">{children}</div>;
};

TabsProvider.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  defaultTab: string
};

Tabs.propTypes = {
  tabs: arrayOf(
    shape({
      label: string.isRequired,
      identifier: string.isRequired,
      icon: shape({ name: string.isRequired, style: oneOf(['fas', 'fad']) })
    })
  ).isRequired,
  className: string,
  type: oneOf(['card'])
};

TabPanel.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  identifier: string.isRequired
};
